module.exports = __webpack_public_path__ + "img/c.b05f9bf4.jpg";